export const getSuppressedClassification = (overrides) => overrides.some((override) => override.classification === "Malicious")
    ? "Malicious"
    : "Suspicious";
export const getSuppressionReason = (classification) => classification.reason ||
    classification.overrides
        .map((override) => override.reason)
        .filter(Boolean)
        .join(", ") ||
    null;
export const getClassificationStatistics = (classification) => {
    if (!classification)
        return [];
    if (classification.overrides.length > 0) {
        const results = [];
        classification.overrides.forEach((override) => {
            const itemIndex = results.findIndex((item) => item.threat_type === override.result);
            if (itemIndex === -1) {
                results.push({
                    threat_type: override.result,
                    total_count: 1,
                });
            }
            else {
                results[itemIndex].total_count++;
            }
        });
        return results;
    }
    else {
        return [
            {
                threat_type: classification.result,
                total_count: 1,
            },
        ];
    }
};
//# sourceMappingURL=utils.js.map